<form [formGroup]="form">
    <div formArrayName="workingDays">
        @for(team of teamMember?.teams; track team){
            <div class="form-horizontal form-box">
                <h4 class="form-box-header">{{'team_member_team_params' | translate:{team:team.teamName} }}</h4>
                @if(team.active){
                <div class="py-2">
                    <div class="row ps-5 py-2 g-0">
                        <label class="col-md-2 col-form-label" for="workingDays">{{'workingDays' | translate}}</label>
                        <div class="col-md-9 pe-4">
                            <tm-working-days [formControlName]="$index" id="workingDays"></tm-working-days>
                        </div>
                        @if(workingDaysDifferentThanDefaults(team)){
                        <div class="text-md-end col-12 pe-4 pt-3">
                            <button type="button" class="btn btn-default" (click)="workingDaysDefault(team)">
                                {{'teamWorkingDays' | translate}}
                            </button>
                        </div>
                        }
                    </div>
                    @if(team.tags?.length>0){
                    <div class="row ps-5 py-2 g-0 align-items-center">
                        <label class="col-md-2 col-form-label" for="tags">{{'your_tags' | translate}}</label>
                        <div class="col-md-10">
                            @for(tag of team.tags; track tag){
                            <span id="tags" class="badge bg-primary me-1">{{tag}}</span>
                            }
                        </div>
                    </div>
                    }
                    <div class="row ps-5 py-2 g-0">
                        <div class="col-md-2"></div>
                        <div class="col-md-10">
                            <button type="button" class="btn btn-danger btn-sm" (click)="toggleTeam(team.teamId)">
                                <i class="fa-regular fa-circle-xmark"></i> {{'leave_team' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
                }
                @else if (!team.active) {
                    <div>
                        <div class="form-group px-5">
                            <div></div>
                            <div class="col-md-10 text-warning">{{'disabled_team_warning' | translate}}</div>
                        </div>
                        <div class="form-group px-5">
                            <div></div>
                            <div class="col-md-10">
                                <button type="button" class="btn btn-primary" (click)="toggleTeam(team.teamId)">
                                    <i class="glyphicon glyphicon-ok-circle"></i> {{'join_team' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }


        <div class="form-horizontal form-box">
            <h4 class="form-box-header">{{'danger_zone' | translate}}</h4>
            <div class="form-group px-4">
                <div></div>
                <div class="col-md-10">
                    <button type="button" class="btn btn-danger" (click)="openDisableDialog()">
                        <i class="glyphicon glyphicon-ban-circle"></i> {{'disable_teammember' | translate}}
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</form>